var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xmark 1",
    clipPath: "url(#clip0_1520_385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.85276 9.85301C9.65736 10.0484 9.3412 10.0484 9.14558 9.85301L4.99964 5.70613L0.852766 9.85301C0.657359 10.0484 0.341203 10.0484 0.145578 9.85301C-0.0498281 9.6576 -0.0498281 9.34145 0.145578 9.14582L4.29339 4.99988L0.146203 0.85301C-0.0492031 0.657604 -0.0492031 0.341447 0.146203 0.145822C0.341609 -0.049584 0.657766 -0.049584 0.853391 0.145822L4.99964 4.29363L9.14651 0.14676C9.34192 -0.0486465 9.65808 -0.0486465 9.8537 0.14676C10.0491 0.342166 10.0491 0.658322 9.8537 0.853947L5.70589 4.99988L9.85276 9.14676C10.0496 9.34051 10.0496 9.65926 9.85276 9.85301Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1520_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9a9db37f1d1c13cc4f2d7b548bde1b4f.svg";
export { ForwardRef as ReactComponent };